import React from 'react';

// Citizens Information brand assets
import citizensLogoFull from './logo-full.png';
import citizensLogoWhite from './logo-white.png';
import citizensLogoIcon from './logo-icon.png';

interface LogoProps {
  width?: string | number;
  height?: string | number;
  alt?: string;
  variant?: 'full' | 'white' | 'icon';
}

export const Logo: React.FC<LogoProps> = ({ 
  width = '200px', 
  height = 'auto', 
  alt = 'Citizens Information',
  variant = 'full'
}) => {
  // Select the appropriate logo variant
  let logoSrc: string;
  switch (variant) {
    case 'icon':
      logoSrc = citizensLogoIcon;
      break;
    case 'white':
      logoSrc = citizensLogoWhite;
      break;
    case 'full':
    default:
      logoSrc = citizensLogoFull;
      break;
  }
  
  return (
    <img 
      src={logoSrc} 
      alt={alt} 
      style={{ 
        width, 
        height,
        maxWidth: '100%'
      }} 
    />
  );
};

export const Icon: React.FC<{ width?: number; height?: number; className?: string }> = ({ 
  width=20, 
  height=20, 
  className 
}) => {
  return (
    <img 
      src={citizensLogoIcon} 
      alt="Citizens Information" 
      width={width}
      height={height}
      className={className}
      style={{ borderRadius: '50%', objectFit: 'cover' }}
    />
  );
};

